export const DEFAULT_PAGE_SIZE = 25;
export const PAGINATION_INTERVALS = [25, 50, 100];
